
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-popupstatus',
  templateUrl: './popupstatus.component.html',
  styleUrls: ['./popupstatus.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PopupstatusComponent implements OnInit {
  @Input() data;
  
  constructor(public modal: NgbActiveModal) { }

  ngOnInit(): void {
    
  }

}
